import React from "react"

interface SelectMenuCategoryProps {
  options: object[],
  onSelect: Function,
  className: string,
}

class SelectMenuCategoryInner extends React.Component<SelectMenuCategoryProps> {
  constructor(props: SelectMenuCategoryProps) {
    super(props)

    this.select = this.select.bind(this)
  }

  select(event) {
    const { onSelect } = this.props
    onSelect(event.target.value)
  }

  renderOption(option, key) {
    return (
      <option value={option.value} key={key}>
        {option.label}
      </option>
    )
  }

  render() {
    const { options, className } = this.props
    return (
      <select onChange={this.select} value="none" className={className}>
        <option disabled value="none">Jump to Menu Category</option>
        {options.map(this.renderOption)}
      </select>
    )
  }
}

export function SelectMenuCategory(props: SelectMenuCategoryProps) {
  return <SelectMenuCategoryInner {...props} />
}
